import { ok } from "assert";

export const TaskProgressBar = function (props: {
    created?: number,
    updated?: number,
    deleted?: number,
    saved?: number,
    oksWithWarnings?: number,
    errors?: number,
    total?: number,
    percent?: number,
    height?: number,
    fatal?: string,
}) {
        const { created, updated, deleted, saved, oksWithWarnings, errors, height, percent } = props;
        let total = props.total;

        const oks_and_warnings = (created||0) + (updated||0) + (deleted||0) + (saved||0);
        const oks = oks_and_warnings - (oksWithWarnings||0);
        const oks_factor = oks_and_warnings? (oks / oks_and_warnings) : 1;

        const nothing_done = !created && !updated && !deleted && !saved && !oksWithWarnings && !errors && !total && percent==100;
        const global_color = nothing_done? (props.fatal? "var(--mig-clear-red)" : "var(--mig-clear-blue)") : "var(--clean-grey)";

        if(!total || total < 0) {
            total = oks + (oksWithWarnings||0) + (errors||0);
            const p = percent || 1; // Avoid showing 100% when no progress is made
            total = (total * 100) / p;
        }
    
        function toPctStr(num: number | undefined, factor: number = 1) {
            return total && num ? (num / total) * factor * 100 + "%" : "0%";
        }
    
        return (
            <div className="bar" style={{width: "100%", height: height?height:"10px", backgroundColor: global_color}}>
                <div style={{width: toPctStr(created, oks_factor), backgroundColor: "var(--mig-green)"}}></div><div 
                style={{width: toPctStr(updated, oks_factor), backgroundColor: "var(--mig-blue)"}}></div><div 
                style={{width: toPctStr(deleted, oks_factor), backgroundColor: "var(--main-brown)"}}></div><div 
                style={{width: toPctStr(saved, oks_factor), backgroundColor: "var(--ligth-purple)"}}></div><div 
                style={{width: toPctStr(oksWithWarnings), backgroundColor: "var(--mig-yellow)"}}></div><div 
                style={{width: toPctStr(errors), backgroundColor: "var(--mig-red)"}}></div>
            </div>
        );
};
